export enum C3GraphicPlacement {
    Left = 'Left',
    Right = 'Right',
    Front = 'Front',
    Top = 'Top',
}

export interface C3GraphicPlacementDefinition {
    placement: C3GraphicPlacement;
    label: string;
    shopName: string;
    primary: boolean;
}

export const C3_GRAPHIC_PLACEMENT_DEFINITIONS: readonly C3GraphicPlacementDefinition[] = [
    { placement: C3GraphicPlacement.Left, label: 'left side', shopName: 'Left', primary: true },
    { placement: C3GraphicPlacement.Right, label: 'right side', shopName: 'Right', primary: true },
    { placement: C3GraphicPlacement.Front, label: 'front', shopName: 'Windshield', primary: false },
    { placement: C3GraphicPlacement.Top, label: 'top', shopName: 'Lid', primary: false },
];

export const C3_GRAPHIC_PLACEMENTS: readonly C3GraphicPlacement[] =
    C3_GRAPHIC_PLACEMENT_DEFINITIONS.map(definition => definition.placement);
